// "Paid" on a Due today card is device-local: it hides the expense from today's
// list on this phone and writes nothing to the server. One localStorage key per
// expense per day, keyed by the server's date (the user's timezone), so the
// mark lapses on its own when the day turns. Shared by the dashboard card
// (due_today_card_controller) and the popup deck (due_deck_controller).
const PREFIX = "floosyo:due-paid:"

// Fired on window whenever an expense is marked paid, so every card showing it
// can drop it without a reload.
export const PAID_EVENT = "due-today:paid"

export function paidIds(today) {
  const ids = new Set()
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (!key?.startsWith(PREFIX)) continue

      const [id, day] = key.slice(PREFIX.length).split(":")
      if (day === today) ids.add(id)
    }
  } catch (_) { }
  return ids
}

export function markPaid(id, today) {
  try {
    localStorage.setItem(`${PREFIX}${id}:${today}`, "1")
  } catch (_) { }
  window.dispatchEvent(new CustomEvent(PAID_EVENT, { detail: { id } }))
}

// Yesterday's marks are dead weight: drop every key not stamped with today.
export function prunePaid(today) {
  try {
    const stale = []
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (key?.startsWith(PREFIX) && !key.endsWith(`:${today}`)) stale.push(key)
    }
    stale.forEach((key) => localStorage.removeItem(key))
  } catch (_) { }
}
